import React from 'react';
import styled, { StylesProps, cx } from '../../../../lib/styles';
import { InputValidationStatus } from '../InputStatus';

import inputLabelStyles from './InputLabel_styles';

export interface InputLabelProps {
  className?: string;
  status?: InputValidationStatus;
  htmlFor?: string;
  required?: boolean;
  children: any;
}

const InputLabel = ({
  className,
  children,
  htmlFor,
  required = true,
  styles,
}: InputLabelProps & StylesProps<typeof inputLabelStyles>) => (
  <label
    htmlFor={htmlFor}
    className={cx('InputLabel', styles.container, className)}
  >
    {children}
    {!required && <span className={styles.optional}>(Optional)</span>}
  </label>
);

export default styled(inputLabelStyles)(InputLabel);
